module.exports = __webpack_public_path__ + "static/product-clipped-dc2a6decbba87892476aa7a1e99795bb.png";